import { render, staticRenderFns } from "./clock-ui.vue?vue&type=template&id=18b1fc04&scoped=true&"
import script from "./clock-ui.vue?vue&type=script&lang=js&"
export * from "./clock-ui.vue?vue&type=script&lang=js&"
import style0 from "./clock-ui.vue?vue&type=style&index=0&id=18b1fc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1fc04",
  null
  
)

export default component.exports